export const references = [
    { url: '/assets/vaag.svg', alt: 'Vaag' },
    { url: '/assets/kattenkwaad.svg', alt: 'Kattenkwaad' },
    { url: '/assets/tomorrowlandLogo.svg', alt: 'Tomorrowland' },
    { url: '/assets/extrema.svg', alt: 'Extrema Outdoor' },
];